import React from 'react';
import { Stack, styled, SelectChangeEvent } from '@mui/material';
import { HeaderClient } from './components/elements/HeaderClient';
import { useInjection } from './hook';
import { InputSelect } from 'app/components/elements/InputSelect';
import { PdfMapFilterBar, PdfMapFilterField, filterFieldSx } from './components/elements/FilterBar';
import { FloorPlanTable } from './components/elements/FloorPlanTable';

export const FloorPlanPage = () => {
  const {
    handleSearch,
    onClickAction,
    handleFilterChange,
    filterParams,
    clientOptions,
    floorOptions,
    locationOptions,
    statusOptions,
    floorplandata,
    pagingInfo,
    sortOption,
    handleSort,
    handleChangePage,
    roomOptions,
    setPagesize,
    handleuploadplan,
    clearFilters
  } = useInjection();

  const hasActiveFilters = !!filterParams?.size;
  return (
    <WrapperCreatePage gap={2.5}>
      <HeaderClient
        onSearch={handleSearch}
        searchholder="Search projects,location, floor or plan"
        uploadPlanButton={{
          label: 'Upload Floor Plan',
          onClick: handleuploadplan
        }}
        paths={[{ name: 'PDF Mapping / Inspection', onClick: () => {}, level: 999 }]}
        title={'PDF Mapping / Inspection'}
      />
      <PdfMapFilterBar onClearFilters={clearFilters} showClearFilters={hasActiveFilters}>
        <PdfMapFilterField xs={6} sm={4} md={2}>
          <InputSelect
            title="Client"
            value={filterParams.get('clientId') || ''}
            placeholder="All Client"
            sx={filterFieldSx}
            onChange={(e: SelectChangeEvent<unknown>) =>
              handleFilterChange('clientId', e.target.value as string)
            }
            options={clientOptions}
          />
        </PdfMapFilterField>
        <PdfMapFilterField xs={6} sm={4} md={2}>
          <InputSelect
            title="Location"
            value={filterParams.get('locationId') || ''}
            placeholder="All Location"
            sx={filterFieldSx}
            onChange={(e: SelectChangeEvent<unknown>) =>
              handleFilterChange('locationId', e.target.value as string)
            }
            options={locationOptions}
          />
        </PdfMapFilterField>
        <PdfMapFilterField xs={6} sm={4} md={2}>
          <InputSelect
            title="Floor"
            value={filterParams.get('floorId') || ''}
            placeholder="All Floor"
            sx={filterFieldSx}
            onChange={(e: SelectChangeEvent<unknown>) =>
              handleFilterChange('floorId', e.target.value as string)
            }
            options={floorOptions}
          />
        </PdfMapFilterField>
        <PdfMapFilterField xs={6} sm={4} md={2}>
          <InputSelect
            title="Rooms"
            value={filterParams.get('floorId') || ''}
            placeholder="All Rooms"
            sx={filterFieldSx}
            onChange={(e: SelectChangeEvent<unknown>) =>
              handleFilterChange('floorId', e.target.value as string)
            }
            options={roomOptions}
          />
        </PdfMapFilterField>
        <PdfMapFilterField xs={6} sm={4} md={2}>
          <InputSelect
            title="Status"
            value={filterParams.get('statusId') || ''}
            placeholder="All statuses"
            sx={filterFieldSx}
            onChange={(e: SelectChangeEvent<unknown>) =>
              handleFilterChange('statusId', e.target.value as string)
            }
            options={statusOptions}
          />
        </PdfMapFilterField>
      </PdfMapFilterBar>

      <Stack>
        <FloorPlanTable
          rows={floorplandata?.floors ?? []}
          pagingInfo={pagingInfo}
          sort={sortOption}
          onSort={handleSort}
          onPageChange={handleChangePage}
          onViewPlan={onClickAction}
          onViewDeficiencies={onClickAction}
          // onGenerateReport={}
        />
      </Stack>
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh'
}));
